// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import countriesListSchema from '@alphaott/common-utils/utils/schemas/countries'

import type { Country } from '@alphaott/api-client/types/countries'

import { FETCH_CHANNEL_COUNTRIES } from '../../actions/channelCountries'

export type ChannelCountriesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Country>,
  +result: Array<string>,
  +expires: ?number,
}

const initialState: ChannelCountriesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  result: [],
  expires: null,
}

const channelCountries = typeToReducer(
  {
    [FETCH_CHANNEL_COUNTRIES]: {
      LOADING: (state): ChannelCountriesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): ChannelCountriesState => {
        const {
          meta: { ttl },
        } = action
        const { result } = normalize(action.payload.data, countriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          result,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): ChannelCountriesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { channelCountries }
